<div class="legend-list" *ngIf="visible$ | async">
  <tm-legend-layer *ngFor="let legendInfo of layers$ | async; trackBy: trackById" [legendInfo]="legendInfo"></tm-legend-layer>
</div>
